"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditSiteInfo = void 0;
var React = require("react");
var stateless_forms_1 = require("../../logistics/forms/stateless_forms");
var buttons_1 = require("../../buttons");
function getSiteInfoFormFields(site_info) {
    return [
        {
            name: "address",
            label: gettext("Address"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXTAREA,
            value: site_info.address || "",
        },
        {
            name: "postcode",
            label: gettext("Postcode"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            value: site_info.postcode || "",
        },
    ];
}
var EditSiteInfo = function (_a) {
    var site_info = _a.site_info, siteInfoSvc = _a.siteInfoSvc, map_id = _a.map_id, siteMapSvc = _a.siteMapSvc, allow_add = _a.allow_add;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement("h3", null, gettext("Site Information")),
                React.createElement(stateless_forms_1.SimpleForm, { fields: getSiteInfoFormFields(site_info), onUpdate: siteInfoSvc.change_data, valuesObject: site_info }))),
        React.createElement("div", { className: "row" },
            map_id && (React.createElement(buttons_1.FileUploadButton, { className: "gamification-sidebar-button", caption: gettext("Change Map"), uploader: function (content) {
                    return siteMapSvc.set_map(content, map_id);
                } })),
            map_id && siteMapSvc && allow_add && (React.createElement(buttons_1.FileUploadButton, { className: "gamification-sidebar-button", caption: gettext("Add Map"), uploader: function (content) {
                    return siteMapSvc.set_map(content, map_id);
                } })),
            React.createElement(buttons_1.Button, { className: "gamification-sidebar-button", onClick: function () { return siteInfoSvc.update(site_info, site_info.id); } }, gettext("Save")))));
};
exports.EditSiteInfo = EditSiteInfo;
